var map = {
	"./added.svg": 49917,
	"./arrow-back.svg": 24520,
	"./arrow-down-small.svg": 43894,
	"./arrow.svg": 44653,
	"./audio.svg": 9243,
	"./audio_speed.svg": 61834,
	"./blink.svg": 73395,
	"./blinkist.svg": 2638,
	"./bookmark-filled.svg": 24885,
	"./bookmark.svg": 9301,
	"./checkbox-checked.svg": 66152,
	"./checkbox-empty.svg": 30028,
	"./checked.svg": 18184,
	"./close.svg": 92077,
	"./delete.svg": 56128,
	"./download.svg": 43911,
	"./error-filled.svg": 24846,
	"./error.svg": 23309,
	"./information.svg": 34455,
	"./key_ideas.svg": 90361,
	"./kindle.svg": 75221,
	"./lock.svg": 30801,
	"./open-external.svg": 70373,
	"./radio-checked.svg": 73314,
	"./radio-empty.svg": 25810,
	"./read.svg": 82174,
	"./search.svg": 95532,
	"./share.svg": 1837,
	"./square-blink.svg": 69141,
	"./star-filled.svg": 76083,
	"./star.svg": 38602,
	"./thumbs-down.svg": 38975,
	"./thumbs-up.svg": 51969,
	"./time.svg": 31712,
	"./trolley.svg": 53652,
	"./user.svg": 59700,
	"sprites/app/added.svg": 49917,
	"sprites/app/arrow-back.svg": 24520,
	"sprites/app/arrow-down-small.svg": 43894,
	"sprites/app/arrow.svg": 44653,
	"sprites/app/audio.svg": 9243,
	"sprites/app/audio_speed.svg": 61834,
	"sprites/app/blink.svg": 73395,
	"sprites/app/blinkist.svg": 2638,
	"sprites/app/bookmark-filled.svg": 24885,
	"sprites/app/bookmark.svg": 9301,
	"sprites/app/checkbox-checked.svg": 66152,
	"sprites/app/checkbox-empty.svg": 30028,
	"sprites/app/checked.svg": 18184,
	"sprites/app/close.svg": 92077,
	"sprites/app/delete.svg": 56128,
	"sprites/app/download.svg": 43911,
	"sprites/app/error-filled.svg": 24846,
	"sprites/app/error.svg": 23309,
	"sprites/app/information.svg": 34455,
	"sprites/app/key_ideas.svg": 90361,
	"sprites/app/kindle.svg": 75221,
	"sprites/app/lock.svg": 30801,
	"sprites/app/open-external.svg": 70373,
	"sprites/app/radio-checked.svg": 73314,
	"sprites/app/radio-empty.svg": 25810,
	"sprites/app/read.svg": 82174,
	"sprites/app/search.svg": 95532,
	"sprites/app/share.svg": 1837,
	"sprites/app/square-blink.svg": 69141,
	"sprites/app/star-filled.svg": 76083,
	"sprites/app/star.svg": 38602,
	"sprites/app/thumbs-down.svg": 38975,
	"sprites/app/thumbs-up.svg": 51969,
	"sprites/app/time.svg": 31712,
	"sprites/app/trolley.svg": 53652,
	"sprites/app/user.svg": 59700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75846;